export const hasAnyPermission = (
  ownedPermissionCodes: readonly string[],
  requiredPermissionCodes: readonly string[]
): boolean =>
  requiredPermissionCodes.length === 0 ||
  requiredPermissionCodes.some((requiredPermissionCode) => ownedPermissionCodes.includes(requiredPermissionCode));
